import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'decimalFormatter'
})
export class DecimalFormatterPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }
  
  transform(value: any, ...args: any[]): any {
   // console.log("value1",value);

    if (value == null || value == undefined || value == 0) {
      return "";
    }

    if( typeof(value) === 'string' ) {
      return value;
    }

    return this.decimalPipe.transform(value, ...args);
  }

}
